;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('svgIcon', svgIcon)

  /* @ngInject */
  function svgIcon () {
    return {
      restrict: 'E',
      scope: {
        name: '@'
      },
      templateNamespace: 'svg',
      link: function (scope) {
        scope.getContentUrl = function () {
          return scope.name ? `/assets/icons/${scope.name}.svg` : ''
        }
      },
      template: '<div ng-if="::name" ng-include="getContentUrl()"></div>'
    }
  }
})()
